import { keccak256, stringToHex, zeroHash } from "viem";
import type { ReferralMilestone } from "../api/referral-schemas";
import type { ReferralSignedAuthorization } from "./referral-mint";

// Source: src/referral/referral-mint.ts. Elysium retains this BE marker;
// the contract's wallet/milestone replay namespace is separate.
const program = keccak256(stringToHex("PONS_REFERRAL_MINT_V1"));
const feeState = keccak256(stringToHex("referral-mint"));

export function verifyReferralProgram(authorization: ReferralSignedAuthorization, milestone: ReferralMilestone): boolean {
  // proofKey is random per authorization. The contract's durable replay key is
  // wallet + milestone, independently of that proofKey and of NFT ownership.
  // The signer chooses the lifetime; preflight checks its bounds against chain
  // time. The contract does not require a fixed 600-second interval.
  return authorization.selectedTierUsd === BigInt(milestone) && authorization.quotedMintFeeWei === 0n &&
    authorization.challengeCommitment.toLowerCase() === program && authorization.feeStateHash.toLowerCase() === feeState &&
    authorization.eligibilitySnapshotHash.toLowerCase() === keccak256(stringToHex(`referral:${authorization.wallet.toLowerCase()}:${milestone}`)) &&
    authorization.coverageRevision === 0n && authorization.asOfBlock === 0n && authorization.asOfBlockHash === zeroHash &&
    authorization.priceTimestamp === 0n && authorization.proofKey !== zeroHash && authorization.authorizationId !== zeroHash &&
    authorization.userContribution !== zeroHash && authorization.deadline > authorization.issuedAt;
}
